<div *ngIf='(vm$ | async) as vm'>
    <app-page-header [vm]="vm" title='User Activity Monitor' [canGoBack]="true" [canRefresh]="true"
        (refreshClick)="refreshPage()" [notify]="notifyObj"></app-page-header>

    <!-- stat panel -->
    <div class="col-md-12 pt-3" *ngIf="vm.statPanelVm as svm">
        <mdb-card narrower="true" cascade="true">
            <app-card-header [title]="svm.data.title" [headingSize]="3"></app-card-header>
            <mdb-card-body cascade="true">
                <div class="row">
                    <div class="col-md-3 pb-3" *ngFor="let s of svm.data.stats">
                        <h6>
                            <strong>{{s.statName}}:</strong>
                            <small class="text-muted pl-1">{{s.intValue}}</small>
                        </h6>
                    </div>
                </div>
            </mdb-card-body>
        </mdb-card>
    </div>

    <div class="row">
        <div class="col-md-6 pt-3" *ngIf="vm.reservationPanelVm as rvm">
            <app-data-table-card [vm]="rvm" [subTitle]="vm.reservationPanelVm.lastUpdateDateTime" [tableMaxHeight]="tableMaxHeight"></app-data-table-card>
        </div>

        <div class="col-md-6 pt-3" *ngIf="vm.dispatchersPanelVm as dvm">
            <app-data-table-card [vm]="dvm" [subTitle]="vm.dispatchersPanelVm.lastUpdateDateTime" [tableMaxHeight]="tableMaxHeight"></app-data-table-card>
        </div>
    </div>

    <div class="row">
        <div class="col-md-6 pt-3" *ngIf="vm.accountingPanelVm as avm">
            <app-data-table-card [vm]="avm" [subTitle]="vm.accountingPanelVm.lastUpdateDateTime" [tableMaxHeight]="tableMaxHeight"></app-data-table-card>
        </div>

        <div class="col-md-6 pt-3" *ngIf="vm.qcPanelVm as qvm">
            <app-data-table-card [vm]="qvm" [subTitle]="vm.qcPanelVm.lastUpdateDateTime" [tableMaxHeight]="tableMaxHeight"></app-data-table-card>
        </div>
    </div>

    <div class="row">
        <div class="col-md-6 pt-3" *ngIf="vm.eventPanelVm as evm">
            <app-data-table-card [vm]="evm" [subTitle]="vm.eventPanelVm.lastUpdateDateTime" [tableMaxHeight]="tableMaxHeight"></app-data-table-card>
        </div>

        <div class="col-md-6 pt-3" *ngIf="vm.salesPanelVm as svm">
            <app-data-table-card [vm]="svm" [subTitle]="vm.salesPanelVm.lastUpdateDateTime" [tableMaxHeight]="tableMaxHeight"></app-data-table-card>
        </div>
    </div>
</div>